import { render, staticRenderFns } from "./CaptchaNonce.vue?vue&type=template&id=308be1c8&"
import script from "./CaptchaNonce.vue?vue&type=script&lang=js&"
export * from "./CaptchaNonce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports